import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import axios from "axios";
import ResponsiveDrawer from "../components/ResponsiveDrawer";
import {
  Box,
  Stack,
  TextField,
  Paper,
  Grid,
  IconButton,
  Modal,
  Typography,
  Button,
  LinearProgress,
} from "@mui/material";
import { DatePicker, LocalizationProvider, MobileDatePicker } from "@mui/lab/";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { makeStyles } from "@material-ui/core";
import * as MdIcons from "react-icons/md";
import { fr } from "date-fns/locale";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: "#F7F8FA",
  },
  toolbar: {
    height: "64px",
  },
  paperDate: {
    width: "500px",
    height: "250px",
    [theme.breakpoints.down("md")]: {
      paddingRight: "10px",
      height: "280px",
      width: "400px",
      paddingRight: "20px",
      height: "35Opx",
    },
  },
  boxDate: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: "20px",
    paddingTop: "20px",
  },
  paperDownload: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 60,
  },
  paperDesign: {
    borderRadius: "10px !important",
    padding: "20px",
    height: "250px",
    width: "650px",
    [theme.breakpoints.down("md")]: {
      height: "280px",
      marginTop: 20,
      width: "400px",
      height: "400px",
    },
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "51px",
    height: "51px",
  },
}));

function DailyReport(props) {
  const classes = useStyles();

  const [dailyDate, setDailyDate] = useState(null);
  const [openFailed, setOpenFailed] = useState(false);
  const [openWait, setOpenWait] = useState(false);

  let tokenStorage = null;
  let month = null;
  let year = null;
  let date = null;

  useEffect(() => {
    if (props.token) {
      tokenStorage = props.token;
    }
  });

  const getDailyReport = async () => {
    setOpenWait(true);
    // need to add 1900 because the method .getYear() in JS removes 1900 to the data
    year = dailyDate.getYear() + 1900;
    month = dailyDate.getMonth() + 1;
    date = dailyDate.getDate();

    await axios
      .get(
        `https://bck-bdx.carloapp.com/api/business/my_daily_report?date=${year}/${month}/${date}`,
        {
          method: "GET",
          responseType: "blob",
          headers: {
            Version: "4.0",
            Authorization: `Bearer ${tokenStorage}`,
          },
        }
      )
      .then((res) => {
        const blog = res.data;
        if (blog.type === "application/json") {
          setOpenFailed(true);
          setOpenWait(false);
        } else {
          setOpenWait(false);
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${date}-${month}-${year}.xls`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      });
  };

  // Redirect user if not logged in
  let isLoggedIn = localStorage.getItem("token");
  if (isLoggedIn) {
    tokenStorage = isLoggedIn.slice(1, isLoggedIn.length - 1);
  }
  // console.log(">>local storage", isLoggedIn);
  if (!props.token && !isLoggedIn) {
    return <Redirect to="/" />;
  }
  if (!props.token && isLoggedIn) {
    props.onSetToken(tokenStorage);
  }

  return (
    <Box sx={{ flexGrow: 1, display: "flex" }}>
      <ResponsiveDrawer />

      <Box className={classes.root} sx={{ flexGrow: 1, p: 3 }}>
        <div className={classes.toolbar}></div>

        <Box ml={2}>
          <h2>Rapport journalier</h2>

          <Grid container>
            <Grid item xs={12} lg={5}>
              <Paper
                className={classes.paperDate}
                sx={{ borderRadius: "10px" }}
              >
                <Box className={classes.boxDate}>
                  <h3>Télécharger votre rapport journalier</h3>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={fr}
                  >
                    <Stack direction="row" spacing={2}>
                      <MobileDatePicker
                        inputFormat="dd/MM/yyyy"
                        openTo="day"
                        views={["year", "month", "day"]}
                        label="Choisir un jour"
                        minDate={new Date("2021-01-01")}
                        maxDate={new Date()}
                        value={dailyDate}
                        onChange={(newDate) => {
                          setDailyDate(newDate);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} helperText={null} />
                        )}
                      />
                      <Paper
                        className={classes.paperDownload}
                        sx={{ backgroundColor: "#006EFF" }}
                      >
                        <IconButton onClick={getDailyReport}>
                          <MdIcons.MdOutlineFileDownload color="white" />
                        </IconButton>
                      </Paper>
                    </Stack>
                  </LocalizationProvider>
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12} lg={7}>
              <Paper className={classes.paperDesign}>
                <Typography
                  mt={1}
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  Retrouver vos rapports journaliers seulement en quelques clics
                  :
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Box>
                    <Typography mt={1} sx={{ fontSize: "16px" }}>
                      - Choisissez le jour que vous désirez
                    </Typography>
                    <Typography mt={1} sx={{ fontSize: "16px" }}>
                      - Cliquez sur l'icône de téléchargement
                    </Typography>
                    <Typography mt={1} sx={{ fontSize: "16px" }}>
                      - Retrouvez directement votre rapport journalier sur votre
                      ordinateur
                    </Typography>
                  </Box>
                  <Box
                    mt={3}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component="img"
                      alt="Component"
                      src="/payment_request_illustration.png"
                      sx={{ width: "160px" }}
                      mr={5}
                    />
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>

        {/* Modal to show progress/wait */}

        <Modal open={openWait}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "#fff",
              p: 4,
              borderRadius: 5,
            }}
          >
            <LinearProgress />
          </Box>
        </Modal>

        {/* Modal to show no daily report exists */}

        <Modal open={openFailed}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "#fff",
              p: 4,
              borderRadius: 5,
            }}
          >
            <IconButton color="error" className={classes.icon}>
              <MdIcons.MdError className={classes.icon} />
            </IconButton>
            <Typography mb={2}>
              Vous n'avez pas effectué de transaction ou reçu de gain parrainage
              ce jour.
            </Typography>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setOpenFailed(false)}
            >
              Fermer
            </Button>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    onSetToken: function (token) {
      dispatch({ type: "setToken", token: token });
    },
  };
}

function mapStateToProps(state) {
  return { token: state.token };
}

export default connect(mapStateToProps, mapDispatchToProps)(DailyReport);
